import {makeAutoObservable} from 'mobx';

interface Settings {
    apiUrl: string;
    classroomApiUrl: string;
    portalIdentifier: string;
    compositionEnvironment: string;
    headers: Record<string, string>;
    isAdmin: boolean;
    // Add other settings properties as needed
}

class SettingsStore {
    private _settings: Settings | null = null;
    private _error: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    get settings(): Settings | null {
        return this._settings;
    }

    get isAdmin(): boolean {
        return this._settings?.isAdmin ?? false;
    }

    get apiUrl(): string | null {
        return this._settings?.apiUrl ?? null;
    }

    get classroomApiUrl(): string | null {
        return this._settings?.classroomApiUrl ?? null;
    }

    get portalIdentifier(): string | null {
        return this._settings?.portalIdentifier ?? null;
    }

    get compositionEnvironment(): string | null {
        return this._settings?.compositionEnvironment ?? null;
    }

    get headers(): Record<string, string> | null {
        return this._settings?.headers ?? null;
    }

    get error(): string | null {
        return this._error;
    }

    updateSettings(settings: Settings) {
        // Only update if the settings have actually changed
        if (JSON.stringify(this._settings) !== JSON.stringify(settings)) {
            this._settings = settings;
        }
    }

    setError(error: string | null) {
        this._error = error;
    }

    reset() {
        this._settings = null;
        this._error = null;
    }
}

export const settingsStore = new SettingsStore();
